export default "__VITE_ASSET__yxqk$Xz1__"